import { Component, Input, OnChanges, SimpleChanges, ViewChild, ElementRef } from '@angular/core';
import { GoogleChartsLoaderService } from '../../services/google-charts-loader.service';

declare const google: any;

@Component({
	standalone: true,
	selector: 'ng-google-charts',
	template: '<div #googleChartDiv></div>',
})
export class NgGoogleChartsComponent implements OnChanges {
	@Input() data: any;
	@Input() pngBase64Callback: (pngBase64: string) => void;

	@ViewChild('googleChartDiv', { static: true }) googleChartDiv!: ElementRef;

	private wrapper: any;

	constructor(private googleChartsLoaderService: GoogleChartsLoaderService) {
		
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['data'] && this.data) {
			this.drawChart();
		}
	}

	private drawChart(): void {
		this.googleChartsLoaderService.load(this.data['chartType']).subscribe(() => {
			this.wrapper = this.wrapper || new google.visualization.ChartWrapper(this.data);
			this.wrapper.setDataTable(this.data['dataTable']);
			this.wrapper.setOptions(this.data['options']);
			google.visualization.events.addListener(this.wrapper, 'ready', () => {
				const pngBase64 = this.wrapper.getChart().getImageURI();
				if (this.pngBase64Callback) {
					this.pngBase64Callback(pngBase64);
				}
			});
			this.wrapper.draw(this.googleChartDiv.nativeElement);
		});
	}
}
